import { MessageView } from 'neon-design-system';
import { baseUrls } from '../../constants/urls';
import { useHistory } from 'react-router-dom';
import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    alignCenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      minHeight: 'calc(100vh - 160px)'
    }
  })
);

export const RestrictedAccessView = () => {
  const { push } = useHistory();
  const classes = useStyles();

  return (
    <div className={classes.alignCenter}>
      <MessageView
        styleName="primary"
        title="Access restricted"
        primaryAction={{
          label: 'Return to Support Center',
          onClick: () => push(baseUrls.home)
        }}
      >
        You currently don’t have permission to access this area of Neon Support Center. Should you require access, please contact the Support team.
      </MessageView>
    </div>
  );
};
